exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".copyright{display:flex;align-items:center;height:80px;position:fixed;bottom:0;left:0;width:100%;font-size:13px}", ""]);

